import { render, staticRenderFns } from "./reason-code.vue?vue&type=template&id=62085f01&scoped=true"
import script from "./reason-code.vue?vue&type=script&lang=js"
export * from "./reason-code.vue?vue&type=script&lang=js"
import style0 from "./reason-code.vue?vue&type=style&index=0&id=62085f01&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62085f01",
  null
  
)

export default component.exports